import React from 'react'
import { Link } from 'react-router-dom'
import Menu from './Menu'

const Sidebar = ({ sidebar }) => {

    return (
        <div className={ ` sidebar ${ sidebar ? "w-[200px] sm:w-full  bg-white h-full overflow-y-auto" : "sm:w-full sm:h-full"}`}>
            <div className=''>
                <div className='text-center'>
                    <div className="logo mb-10 pt-3">
                        <Link to="/" className='text-2xl font-medium '>MKSOFT</Link>
                    </div>
                    <div>
                        <div className='_shadow-md inline-block rounded-md overflow-hidden mb-3'>
                            <img src="https://www.einfosoft.com/templates/admin/spiceangular/source/light/assets/images/usrbig.jpg" alt="" className='w-16 p-[2px] rounded-md mx-auto' />
                        </div>
                        <p className='leading-3'>Emily Smith</p>
                        <span className='text-xs'>Manager</span>
                    </div>
                </div>
                <div>
                    <Menu/>
                </div>
            </div>
        </div>
    )
}

export default Sidebar